import { fork, all } from "redux-saga/effects";

import deployments from "./deployments";
import pipelines from "./pipelines";

export default function* startup() {
  // These can run before the user chooses a project
  const sagas = [deployments, pipelines];

  yield all(sagas.map((saga) => fork(saga)));
}
